

import ReactLauncher from './ReactLauncher';
import { TCCCalendar } from './Calendar/TCCCalendar';
ReactLauncher([
  { tagName: 'TCCCalendar', component: TCCCalendar },
]);